import actions from "./actions"

const initialState = {
    ecoDrivingScore: [],
    ecoDrivingGlobalSetting: [],
    ecoDrivingVehicleSetting: [],

};

export default function ecoDrivingReducers(state = initialState, action:{payload: any, type: any}):any{
    switch(action.type){
        case actions.SET_ECO_DRIVING_DATA_BY_VEHICLE_ID:
            return {...state, ecoDrivingScore: action.payload};
        case actions.SET_ECO_DRIVING_GLOBAL_SETTINGS:
            return {...state, ecoDrivingGlobalSetting: action.payload};
        case actions.SET_ECO_DRIVING_SETTING_BY_VEHICLE_ID:
            return {...state, ecoDrivingVehicleSetting: action.payload};
        default:
            return state;
    }
}